module.exports = __webpack_public_path__ + "assets/img/NC.8abed8d5.png";